// frontend/src/i18n/languages.js
//
// The languages the app is translated into: what every language picker
// offers, and the only values the server stores (`core.models.LANGUAGE_CHOICES`).

import en from './locales/en.json';
import es from './locales/es.json';
import pl from './locales/pl.json';
import nl from './locales/nl.json';

export const resources = {
  en: { translation: en },
  es: { translation: es },
  pl: { translation: pl },
  nl: { translation: nl },
};

export const APP_LANGUAGES = Object.keys(resources);
